<template>

  <rate-calendar-popup :title="item.inventory.event?.name ?? '(unknown event)'">

    <template v-slot:tools>
      <v-btn-group>
        <v-btn icon="$edit" @click="$emit('edit')" />
        <v-btn icon="$delete" @click="$emit('delete')" />
      </v-btn-group>
    </template>

    <p>
      {{ item.inventory.event?.name }}
      <template v-if="canSeeIds">
        ({{ item.inventory.eventID ?? '?' }})
      </template>
    </p>

    <p class="mt-2">
      <strong>Venue:</strong> <!-- TODO: i18n -->
      {{ item.inventory.event?.venue?.name ?? '(unknown venue)' }}
      <template v-if="canSeeIds">
        ({{ item.inventory.event?.venueID ?? '?' }})
      </template>
    </p>

    <p class="mt-2">
      <strong>Time:</strong> <!-- TODO: i18n -->
      {{ time }}
    </p>

    <table class="calendar-popup-table mt-2">
      <thead>
        <tr>
          <th scope="col">{{ $t('titles.spot_override') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="eventTier in item.inventory.eventTiers" :key="eventTier.ID">
          <td>
            <span :class="{'font-weight-bold': eventTier.ID === item.inventory.eventInventoryTier?.currentEventTierID}">
              {{ currencyFormatter.format(eventTier.tierPrice) }}
              up to {{ percentageFormatter.format(eventTier.tierInventoryPercentage) }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>

  </rate-calendar-popup>

</template>

<script setup lang="ts">

import { computed } from 'vue'

// components
import RateCalendarPopup from './RateCalendarPopup.vue'

// misc
import PermissionsService from '../../../../../services/PermissionsService'
import type { EventExceptionItem } from '../types'
import { currencyFormatter, percentageFormatter } from '../../../../../utils/formatters'
import { Temporal } from '@js-temporal/polyfill'
import PreferencesService from '../../../../../services/PreferencesService'

interface Props {
  item: EventExceptionItem
}

const props = defineProps<Props>()
defineEmits(['edit', 'delete'])

const canSeeIds = PermissionsService.can('seeids')

const time = computed<string>(() => {

  const locale = PreferencesService.preferences.locale
  let formattedStart = '?', formattedEnd = '?'

  try {
    const start = Temporal.PlainDateTime.from(props.item.inventory.event.eventStartLocal)
    formattedStart = start.toLocaleString(locale, {timeStyle: 'short'})
  } catch(e) {
    // fail silently
  }

  try {
    const end = Temporal.PlainDateTime.from(props.item.inventory.event.eventEndLocal)
    formattedEnd = end.toLocaleString(locale, {timeStyle: 'short'})
  } catch(e) {
    // fail silently
  }

  return `${formattedStart} – ${formattedEnd}`

})

</script>
